/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/metadata';
import '../../common/currency';
import '../../payments/icc';
import '../../common/location';
import '../common/common';
import '../../common/emv';
import '../../common/time';
import '../../payments/capture';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "CaptureType": {
                "values": {
                  "DEFAULT_CAPTURE_TYPE_DO_NOT_USE": 0,
                  "CAPTURE_OTHER": 1,
                  "CAPTURE_HUMAN_INITIATED": 2,
                  "CAPTURE_CLIENT_INITIATED_TIMEOUT": 3,
                  "CAPTURE_SERVER_INITIATED_TIMEOUT": 4,
                  "CAPTURE_MERCHANT_INITIATED": 5,
                  "CAPTURE_SUPPORT_INITIATED": 6
                }
              },
              "CaptureOptions": {
                "fields": {
                  "suspendTransactionLimits": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isTivoReplay": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "CaptureRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "squareup.esperanto.common.Metadata",
                    "id": 2,
                    "rule": "optional"
                  },
                  "taxAmount": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipAmount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "options": {
                    "type": "squareup.esperanto.api.CaptureOptions",
                    "id": 6,
                    "rule": "optional"
                  },
                  "creatorToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "includePaymentRecord": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "iccData": {
                    "type": "squareup.payments.icc.CaptureRequestIccData",
                    "id": 10,
                    "rule": "optional"
                  },
                  "captureRequestId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "geoLocation": {
                    "type": "squareup.common.location.GeoLocation",
                    "id": 14,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "billInfo": {
                    "type": "squareup.esperanto.common.BillInfo",
                    "id": 16,
                    "rule": "optional"
                  },
                  "captureType": {
                    "type": "squareup.esperanto.api.CaptureType",
                    "id": 17,
                    "rule": "optional"
                  },
                  "emvTags": {
                    "type": "squareup.common.EmvTags",
                    "id": 18,
                    "rule": "optional"
                  },
                  "captureIntentAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 19,
                    "rule": "optional"
                  },
                  "isStoreAndForward": {
                    "type": "bool",
                    "id": 24,
                    "rule": "optional"
                  },
                  "clientRequestedAtMs": {
                    "type": "int64",
                    "id": 22,
                    "rule": "optional"
                  },
                  "buyerToMerchantExchange": {
                    "type": "squareup.esperanto.common.ForeignExchange",
                    "id": 23,
                    "rule": "optional"
                  }
                }
              },
              "CaptureResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "error": {
                    "type": "squareup.payments.capture.CaptureError",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentRecord": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CaptureType && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CaptureOptions && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CaptureRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CaptureResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CaptureType @ squareup/esperanto/api/capture.proto at 19:1
 */
export const CaptureType = $root.lookupEnum('squareup.esperanto.api.CaptureType').values;
/**
 * SOURCE CaptureOptions @ squareup/esperanto/api/capture.proto at 61:1
 */
export const CaptureOptions = $root.lookupType('squareup.esperanto.api.CaptureOptions');
fixType(CaptureOptions);
Builder.createAndAttachToType(CaptureOptions);
/**
 * SOURCE CaptureRequest @ squareup/esperanto/api/capture.proto at 74:1
 */
export const CaptureRequest = $root.lookupType('squareup.esperanto.api.CaptureRequest');
fixType(CaptureRequest, {
  paymentId: {
    required: true
  },
  totalAmount: {
    required: true
  },
  creatorToken: {
    required: true
  }
});
Builder.createAndAttachToType(CaptureRequest);
/**
 * SOURCE CaptureResponse @ squareup/esperanto/api/capture.proto at 175:1
 */
export const CaptureResponse = $root.lookupType('squareup.esperanto.api.CaptureResponse');
fixType(CaptureResponse);
Builder.createAndAttachToType(CaptureResponse);